<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { FormDef } from '../../../../Types/form'
import type { TotpSetup } from '../../../../Types/user'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import FormCreator from '../UI/Form/FormCreator.vue'

// Props
defineProps<{
  def: FormDef
  sending: boolean
  setup: TotpSetup
}>()

// Emits
const emit = defineEmits<{
  submit: []
}>()

// Composables
const { t } = useI18n()

// Ref
const form = ref<typeof FormCreator | null>(null)

// Methods
function submit() {
  emit('submit')
}
</script>

<template>
  <div class="d-flex mt-4">
    <div class="flex-shrink-0">
      <img :src="setup.qrCode" width="320" alt="qrcode" class="img-fluid" data-test="totp-setup-form-qrcode" />
    </div>
    <div class="flex-grow-1 ml-4 mt-1">
      <FormCreator ref="form" dynamic :config-def="def" :config-object="setup" class-to-add="d-none" />

      <template v-if="form">
        <div class="row">
          <div class="col-6">
            <FieldCreator
              name="secret"
              form-ref="formtotp"
              domain="2fa.totp.setup"
              :form-data="form"
              label-top
              data-test="totp-setup-form-secret"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="d-flex">
              <div><i class="fas fa-info-circle text-info"></i></div>
              <div class="ml-2">
                <div>{{ t('2fa.totp.setup.manual_setup') }}</div>
                <div class="mt-1">
                  <a :href="setup.uri">{{ setup.uri }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 mt-2">
            <FieldCreator
              v-model="setup.code"
              name="code"
              form-ref="formtotp"
              domain="2fa.totp.setup"
              :form-data="form"
              label-top
              data-test="totp-setup-form-code"
            />
          </div>
        </div>
        <div class="mt-2">
          <ButtonAll type="validation" margin="no" label="2fa.totp.setup.enable" :loading="sending" @click="submit" />
        </div>
      </template>
    </div>
  </div>
</template>
